<!--
 * @Description: 复选框组件
 * @Date: 2023-08-20
-->
<template>
  <div class="schema-checkbox">
    <el-checkbox v-model="checked" @change="handleChange">{{ label }}</el-checkbox>
  </div>
</template>

<script>
export default {
  name: 'SchemaCheckbox',
  
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    }
  },
  
  data() {
    return {
      checked: false
    };
  },
  
  watch: {
    value: {
      handler(val) {
        this.checked = !!val;
      },
      immediate: true
    }
  },
  
  methods: {
    handleChange(val) {
      this.$emit('input', val);
    }
  }
};
</script>

<style lang="scss" scoped>
.schema-checkbox {
  margin-bottom: 10px;
}
</style> 